import { TOOLBAR_DROPDOWN_OPENED } from 'OK/ToolbarDropdownEventBuses';
import logger from 'OK/logger';
import { firstByClass } from 'OK/utils/dom';
import { isScrolling, onScrollStarted, onScrollStopped } from 'OK/utils/windowScrolling';
import { onActivityStart, onActivityStop } from 'OK/utils/userActivity';
import toolbarGrowlConfig from 'OK/pms!toolbarGrowlConfig';

var SWF_ELEMENT_ID = 'CallApplication',
    APP_MAIN_STATE_ID = 'appMain',
    DISCOVERY_STATE_WITH_SEARCH = '.discovery-menu.with-search.__search-wide',
    ACTIVE_CSS_CLASS_NAME = '__active',
    LOG_OPERATION = 'growl',
    CLICK_EVENT_NAME = 'click',
    ID_ATTR = 'data-id',
    LOCAL_STORAGE_KEY = 'toolbar-growl',
    TRANSITION_END_EVENT_NAME = (function () {
        // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
        // ============================================================
        var result,
            name,
            el = document.createElement('bootstrap'),
            transEndEventNames = {
                'transition': 'transitionend',
                'OTransition': 'oTransitionEnd',
                'MozTransition': 'transitionend',
                'WebkitTransition': 'webkitTransitionEnd'
            };

        for (name in transEndEventNames) {
            if (transEndEventNames.hasOwnProperty(name) && el.style[name] !== undefined) {
                result = transEndEventNames[name];
                break;
            }
        }

        logger.success(LOG_OPERATION, 'transition', result);

        return result;
    }()),
    current = null, /** @type {ToolbarGrowl} текущее показанное оповещение */
    growls = {}, /** @type {Object.<String, ToolbarGrowl>} все активированные выпадашки */
    msgToolbarButton = document.getElementById('msg_toolbar_button'),
    msgAdditionalLogEnabled = !!(msgToolbarButton && msgToolbarButton.getAttribute('data-growl-add-log')),
    isMsgOKLayer = !!document.querySelector('.js-msg-ok'),
    isMsgTTLayer = !!document.querySelector('.js-msg-tt'),
    showAnyCalledWhileScrolling = false,
    currentSetTimestamp = 0,
    userActivityStartTimestamp = 0,
    userActivityTime = 0;

/**
 * @typedef {Object} GrowlStorageData
 * @property {boolean} [isViewed]
 */

/**
 * @typedef {Object.<string, GrowlStorageData>} GrowlsData
 */

/**
 * @type {Object.<string, GrowlsData>}
 */
var localStorageData;

try {
    const storage = localStorage.getItem(LOCAL_STORAGE_KEY);

    localStorageData = storage
        ? JSON.parse(storage)
        : {};
} catch (e) {
    localStorageData = null;
}

/**
 * @typedef {Object} PMSConfig
 * @property {boolean} hideOnScroll - прятать при скролле
 * @property {number} showAfterScrollDelay - задержка показа после скролла
 * @property {number} hideIgnoredAfterUserActivity - прятать после суммарной активности пользователя (если игнорил уведомление)
 */

/**
 * @type {PMSConfig | null}
 */
var config = toolbarGrowlConfig.config;
/**
 * @type {string}
 */
var userId = toolbarGrowlConfig.userId;

if (config && config.hideIgnoredAfterUserActivity) {
    var key = 'ToolbarGrowl';

    onActivityStart(key, function (idleTime) {
        userActivityStartTimestamp = Date.now();
    });

    onActivityStop(key, function (activeTime) {

        /**
         * если показали текущий элемент после начала активности, то вычитаем это время
         * иначе, после завершения активности, тултип может сразу закрыться из-за долгой активности
         */
        if (currentSetTimestamp > userActivityStartTimestamp) {
            activeTime -= currentSetTimestamp - userActivityStartTimestamp;
        }

        // накапливаем активность пользователя
        userActivityTime += activeTime;

        // сбрасываем активность и закрываем текущий элемент
        if (current && userActivityTime >= config.hideIgnoredAfterUserActivity) {
            current.clickClose();
            userActivityTime = 0;
            ToolbarGrowl.showAny();
        }
    });
}

/**
 * @param {string} growlId
 * @param {GrowlStorageData} data
 */
function saveGrowlData(growlId, data) {
    if (userId && localStorageData) {
        const userLocalStorageData = localStorageData[userId] || {};

        userLocalStorageData[growlId] = Object.assign(userLocalStorageData[growlId] || {}, data);
        localStorageData[userId] = userLocalStorageData;

        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(localStorageData));
    }
}

/**
 * @param {string} growlId
 * @returns {GrowlStorageData | null}
 */
function getGrowlData(growlId) {
    if (userId && localStorageData) {
        const userLocalStorageData = localStorageData[userId] || {};

        if (userLocalStorageData) {
            return userLocalStorageData[growlId];
        }
    }

    return null;
}

/**
 * @param {string} growlId
 * @returns {boolean}
 */
function isGrowlViewed(growlId) {
    const growlData = getGrowlData(growlId);

    return Boolean(growlData && growlData.isViewed);
}

/**
 * @param element
 * @returns {number} время создания выпадашки
 */
function parseTime(element) {
    if (element) {
        return parseInt(element.getAttribute('data-time'), 10) || 0;
    }
    return 0;
}

/**
 * Проверяет наличие открытых лееров
 * @returns {boolean} открыт ли какой-нибудь леер
 */
function isAnyLayerOpened() {
    return OK.Layers && OK.Layers.isAnyLayerOpened();
}

/**
 * Проверяет можно ли показывать выпадашку сейчас.
 * Выпадашку нельзя показывать если открыт поплеер,
 * флешка видео-звонков, на странице игр (appMain), на странице discovery в режиме поиска
 * @return {boolean} можно показывать выпадашку
 */
function canShowGrowl() {
    return !(isAnyLayerOpened() ||
        document.getElementById(SWF_ELEMENT_ID) ||
        document.querySelector(DISCOVERY_STATE_WITH_SEARCH) ||
        OK.getCurrentDesktopModelId() === APP_MAIN_STATE_ID ||
        (this.isDisposedAfterViewed && isGrowlViewed(this.id)));
}

/**
 * Преобразовывает HTML в элемент
 * @param {string} html хтмл
 * @returns {HTMLElement} element
 */
function toElement(html) {
    var holder = document.createElement('div');
    holder.innerHTML = html;
    return holder.children.length ? holder.children[0] : null;
}

/**
 * @returns {Element} кнопка закрытия выпадашки
 */
function getCloseButton(element) {
    return firstByClass(element, 'growl_close');
}

function scrollStartedHandler() {
    if (this.elem && !this.hidden) {
        this.elem.classList.remove(ACTIVE_CSS_CLASS_NAME);
    }
}

function scrollStoppedHandler() {
    clearTimeout(this.showAfterScrollStoppedTimer);
    this.showAfterScrollStoppedTimer = setTimeout(showAfterScrollStopped.bind(this), config.showAfterScrollDelay);
}

function showAfterScrollStopped() {
    if (showAnyCalledWhileScrolling) {
        showAnyCalledWhileScrolling = false;
        ToolbarGrowl.showAny();

        return;
    }

    if (this.elem && !this.hidden) {
        this.elem.classList.add(ACTIVE_CSS_CLASS_NAME);
    }
}

/**
 * @param {string} hookId id хука
 *
 * @property {boolean} hidden скрыто ли сейчас оповещение?
 * @property {Object.<String, String|Number>} stash во время выполнения анимации сюда сохраняется хтмл следующего оповещения
 * @property {Object} hook хук для активации/деактивации выпадаешек (one.gwt.hook.client.IHook)
 * @property {Node} elem
 * @property {string} id оповещения
 * @property {number} time время создания оповещения
 * @property {string} layerId название леера. Если он открыт пришедшее по пушу оповещение игнорируется
 * @property {number | null} showAfterScrollStoppedTimer таймер отображения после скролла
 * @property {Function} onScrollStartedDestroy функция отписки от события скролла
 * @property {Function} onScrollStoppedDestroy функция отписки от события скролла
 */
class ToolbarGrowl {
    constructor(hookId) {
        this.hookId = hookId;
        this.hidden = true;
        this.stash = null;

        this.markAsViewed = () => {
            saveGrowlData(this.id, {isViewed: true});
        };

        this.destroyGrowl = () => this.destroy();
    }

    /**
     * Пробегаемся по активированным выпадашкам и показываем первую
     */
    static showAny() {
        var id, growl;

        if (current) { // одна из выпадашек уже показана
            return;
        }

        // показ будет вызван повторно, после завершения скролла
        if (config && config.hideOnScroll && isScrolling()) {
            showAnyCalledWhileScrolling = true;
            return;
        }

        for (id in growls) {
            if (growls.hasOwnProperty(id)) {
                growl = growls[id];
                if (growl.hidden) {
                    growl.show();
                    if (!growl.hidden) {
                        break;
                    }
                }
            }
        }
    }

    /**
     * Пробегаемся по активированным выпадашкам и показываем первую
     */
    static hideAll() {
        if (current) {
            current.hide();
        }
    }

    /**
     * Закрывает выпадашку, найдя ее по id леера
     * @param layerId id леера в леер менеджере
     */
    static destroyByLayerId(layerId) {
        var growl = growls[layerId];
        if (growl) {
            growl.destroy();
        }
    }

    /**
     * @param layerId id леера в леер менеджере
     * @returns {ToolbarGrowl} выпадашка леера
     */
    static getByLayerId(layerId) {
        return growls[layerId];
    }

    /**
     * Activate hook.
     * @param element hook element
     */
    activate(element) {
        this.hook = this.getContentHook();
        this.layerId = element.getAttribute('data-layer');
        this.exclusive = element.getAttribute('data-exclusive') === 'true';
        this.isDropdownGrowl = element.getAttribute('data-dropdown-growl') === 'true';
        this.isDisposedAfterViewed = element.getAttribute('data-disposed-after-viewed') === 'true';
        this.priority = parseInt(element.getAttribute('data-priority'), 10) || 0;
        this.handleFocusOut = (e) => {
            if (!this.elem.contains(e.relatedTarget)) {
                this.clickClose();
            }
        };

        growls[this.layerId] = this; // регистрируем выпадашку в зарегистрированных
        if (this.hook) {
            this.elem = this.hook.element.firstElementChild;
            if (this.elem) {
                this.activateGrowl();
                this.id = this.elem.getAttribute(ID_ATTR);
                this.time = parseTime(this.elem);
            }
        }

        if (config) {
            // временно прячем при скролле
            if (config.hideOnScroll) {
                var key = 'ToolbarGrowl-' + this.layerId;
                this.onScrollStartedDestroy = onScrollStarted(key, scrollStartedHandler.bind(this));
                this.onScrollStoppedDestroy = onScrollStopped(key, scrollStoppedHandler.bind(this));
            }
        }

        this.show(); // пытаемся показать
    }

    deactivate() {
        if (this.onScrollStartedDestroy) {
            this.onScrollStartedDestroy();
        }

        if (this.onScrollStoppedDestroy) {
            this.onScrollStoppedDestroy();
        }
    }

    clickClose() {
        var closeButton = getCloseButton(this.elem);
        if (closeButton && closeButton['click']) {
            closeButton.click();
        }
    }

    activateGrowl() {
        var closeButton = getCloseButton(this.elem);
        if (closeButton) {
            closeButton.addEventListener(CLICK_EVENT_NAME, this);
        }

        if (this.isDropdownGrowl) {
            TOOLBAR_DROPDOWN_OPENED.on(this.destroyGrowl, this);
        }

        if (this.isDisposedAfterViewed) {
            this.elem.addEventListener('click', this.markAsViewed, true);
        }
    }

    deactivateGrowl() {
        var closeButton = getCloseButton(this.elem);
        if (closeButton) {
            closeButton.removeEventListener(CLICK_EVENT_NAME, this, true);
        }

        if (this.isDropdownGrowl) {
            TOOLBAR_DROPDOWN_OPENED.off(this.destroyGrowl);
        }

        if (this.isDisposedAfterViewed) {
            this.elem.removeEventListener('click', this.markAsViewed);
        }
    }

    /**
     * Показывает всплывашку если она есть и можно ее показывать
     * (не открыты лееры, не appMain и т.д.)
     */
    show() {
        if (this.id && canShowGrowl.call(this)) {
            if (current) {
                if (this.priority <= current.priority) {
                    return;
                } else {
                    logger.success(LOG_OPERATION, 'replace', this.layerId);
                    current.hide();
                }
            }

            this.elem.addEventListener('focusout', this.handleFocusOut);
            this.elem.classList.add(ACTIVE_CSS_CLASS_NAME);
            this.hidden = false;

            // сбрасываем таймер активности, если изменился отображаемый элемент
            if (current !== this) {
                userActivityTime = 0;
                currentSetTimestamp = Date.now();
            }

            current = this;
            logger.success(LOG_OPERATION, 'show', this.layerId === 'music_app' ? this.layerId + '-' + this.id : this.layerId);

            if (this.layerId === 'messages' && msgAdditionalLogEnabled) {
                var param2 = isMsgTTLayer ? 'tt'
                    : isMsgOKLayer ? 'ok' : 'unknown';
                return logger.success('messagesLayer', 'growl', param2);
            }
        }
    }

    /**
     * Прячет текущую выпадашку.
     */
    hide() {
        if (this.elem) {
            this.elem.removeEventListener('focusout', this.handleFocusOut);
            this.elem.classList.remove(ACTIVE_CSS_CLASS_NAME);
            this.hidden = true;
            if (this === current) {
                current = null;
            }
        }
    }

    /**
     * Прячет текущую выпадашку и удаляет ее из дом-дерева
     */
    destroy() {
        if (this.elem) {
            this.deactivateGrowl();
            this.hide();
            this.id = null;
            this.time = null;
            this.elem = null;
        }
    }

    /**
     * Получение новых данных с сервера (по пушу)
     * @param html HTML с сервера
     */
    setNewContent(html) {
        var self = this, element = toElement(html), id, time;

        if (OK.Layers && OK.Layers.isLayerOpened(self.layerId)) { // леер открыт
            logger.success(LOG_OPERATION, 'ignore');
        } else if (element) {
            id = element.getAttribute(ID_ATTR);
            time = parseTime(element);

            if (this.exclusive && this.id && this.id !== id) {
                return;
            }

            if (self.id === id && self.time === time) {
                logger.success(LOG_OPERATION, 'equal', 1);
                return;
            }

            if (self.hidden) {
                this.setNewGrowl(html, id, time);
            } else {
                this.stash = {html: html, id: id, time: time};

                this.elem.addEventListener(TRANSITION_END_EVENT_NAME, this, false);
                self.destroy();
            }
            // Перерисовались в пустоту
        } else {
            self.destroy();
            ToolbarGrowl.showAny(); // и пробуем показать выпадашку из другого раздела
        }
    }

    applyNewContent() {
        this.hidden = true;

        if (this.stash === null) {
            OK.hookModel.setHookContent(this.getContentHookId(), '');
        } else {
            this.setNewGrowl(this.stash.html, this.stash.id, this.stash.time);
            logger.success(LOG_OPERATION, 'replace');
            this.stash = null;
        }
    }

    /**
     * Задает, активирует и показывает новое оповещение.
     * @this ToolbarGrowl
     * @param html
     * @param id
     * @param time
     */
    setNewGrowl(html, id, time) {
        if (this.id === id && this.time === time) {
            logger.success(LOG_OPERATION, 'equal', 2);
            return;
        }
        var contentHook = this.getContentHook();
        OK.hookModel.setHookContent(contentHook.id, html);
        this.elem = contentHook.element.firstChild;
        this.id = id;
        this.time = time;
        this.activateGrowl();
        setTimeout(this.show.bind(this), 30);
    }

    /**
     * Обработчик событий
     * @param e
     */
    handleEvent(e) {
        var type = e.type;
        if (type === CLICK_EVENT_NAME) { /** Срабатывает при клике на крестик */
            if (this.time > this.crossTime) {
                this.crossTime = this.time;
            }
            this.destroy(); // закрываем эту
            ToolbarGrowl.showAny(); // и пробуем показать выпадашку из другого раздела
        } else if (type === TRANSITION_END_EVENT_NAME) { /** Срабатывает один раз в конце анимации скрытия выпадашки */
            if (e.propertyName === 'opacity') {
                e.target.removeEventListener(TRANSITION_END_EVENT_NAME, this);
                this.applyNewContent();
            }
        }
    }

    getContentHookId() {
        return this.hookId + '_Content';
    }

    getContentHook() {
        if (!this.hook) {
            this.hook = OK.hookModel.getHookById(this.getContentHookId());
        }
        return this.hook;
    }
}


export default ToolbarGrowl;

var showAny = ToolbarGrowl.showAny;
var hideAll = ToolbarGrowl.hideAll;
var destroyByLayerId = ToolbarGrowl.destroyByLayerId;
var getByLayerId = ToolbarGrowl.getByLayerId;

export { showAny, hideAll, destroyByLayerId, getByLayerId };
